var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.3736,
    height: 48.3736,
    rx: 24.1868,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.858 23.8593C12.241 23.2464 11.7522 22.5168 11.42 21.7131C11.0878 20.9094 10.9189 20.0476 10.9231 19.1779C10.9231 17.4191 11.6218 15.7322 12.8655 14.4885C14.1092 13.2448 15.7961 12.5461 17.5549 12.5461C20.0204 12.5461 22.1738 13.888 23.313 15.8854H25.0607C25.6398 14.8696 26.4777 14.0255 27.4892 13.4389C28.5006 12.8523 29.6494 12.5443 30.8187 12.5461C32.5776 12.5461 34.2644 13.2448 35.5081 14.4885C36.7518 15.7322 37.4506 17.4191 37.4506 19.1779C37.4506 21.0036 36.6703 22.6889 35.5156 23.8593L24.1868 35.1724L12.858 23.8593ZM36.6079 24.9672C38.0903 23.4691 39.011 21.4406 39.011 19.1779C39.011 17.0052 38.1479 14.9215 36.6115 13.3851C35.0752 11.8487 32.9914 10.9856 30.8187 10.9856C28.0879 10.9856 25.6692 12.312 24.1868 14.3718C23.4302 13.3208 22.4338 12.4654 21.2805 11.8765C20.1271 11.2876 18.85 10.9822 17.5549 10.9856C15.3822 10.9856 13.2985 11.8487 11.7621 13.3851C10.2258 14.9215 9.36264 17.0052 9.36264 19.1779C9.36264 21.4406 10.2833 23.4691 11.7657 24.9672L24.1868 37.3883L36.6079 24.9672Z",
    fill: "#232020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e34d84b18a6f62abb467311d9f62f7dd.svg";
export { ForwardRef as ReactComponent };